module.exports = __webpack_public_path__ + "static/img/ic.c2a4205.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic.png
// module id = 1QIJ
// module chunks = 1